module.exports = __webpack_public_path__ + "img/case1.fc9d8af2.png";